export enum approvalManagementTypes {
  user = "user",
  role = "role",
}
